(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["idx"] = factory();
	else
		root["idx"] = factory();
})(window, function() {
return 


// WEBPACK FOOTER //
// webpack://idx/webpack/universalModuleDefinition